import React, { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import './HeroBanner.css';
import { ROOT_IMG_URL } from '../../../GlobalValues';

const HeroBanner = ({ isLocationPage = false }) => {
  const [state] = useContext(StateContext);

  // Extract city from autocomplete data for non-location pages
  const getCityFromAutocomplete = (autocompleteData) => {
    if (!autocompleteData) return null;

    // For location pages, use full address_line1
    if (isLocationPage) {
      return autocompleteData.address_line1;
    }

    // For search/geolocation, use the city field directly
    return autocompleteData.city || null;
  };

  const autocompleteCity = getCityFromAutocomplete(state?.sl?.autocompleteData);
  const firstMerchant = state?.merchants?.[0];
  const merchantCity = firstMerchant?.address?.city || null;
  const subtitle = autocompleteCity || merchantCity;

  const banner = `${ROOT_IMG_URL}/hero.jpg`;
  return (
    <div className="hero-banner-wrapper sl-relative sl-flex sl-jc-center sl-ai-center">
      <div
        className="sl-flex sl-flex-col sl-gap-s  sl-absolute sl-ai-center sl-w-100 sl-h-100 sl-jc-center"
        style={{
          backgroundColor: 'rgba(6,5,11,0.5)',
          zIndex: 1,
        }}
      >
        <h1 className="sl-title-bloc big-t">NOS SALONS</h1>
        {subtitle && <p className="sl-title-bloc big-t">{subtitle}</p>}
      </div>
      <img src={banner} alt="Hero Banner" className="hero-banner-image" />
    </div>
  );
};

export default HeroBanner;
